import React, { useState, useEffect } from 'react';
import ButtonBuilder from './SharedParts/ButtonBuilder';
function Contact(props) {

  useEffect(() => { document.title = props.title }, [])

  return (
    <div className="main-content-padding-top main-content-padding-x">
      <div className="container">
        <div className="row">
          <div className="col">
            <h2>Looking to contact me?</h2>
            <h5>Try These:</h5>
            <p>
              <ButtonBuilder
              type="mail"
              linkUrl="robertshumble@gmail.com"
              linkText="Email - robertshumble@gmail.com"
            ></ButtonBuilder>
            </p>
            <p>
              <a href="https://www.linkedin.com/in/rob-humble-40b73445/">
                <img
                  src="https://static.licdn.com/scds/common/u/img/webpromo/btn_viewmy_160x33.png"
                  width="160"
                  height="33"
                  border="0"
                  alt="View Robert Humble's profile on LinkedIn"
                />
              </a>
            </p>
            <ButtonBuilder
              type="gitHub"
              linkUrl="https://github.com/robhumble"
              linkText="GitHub Profile"
            ></ButtonBuilder>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Contact;